import { useState } from 'react';
import { Button, IconButton, Popover } from '@mui/material';
import VerticalDotsIcon from 'assets/icons/buttons/table-dots.svg';
import DeleteIcon from 'assets/icons/buttons/delete.svg';
import RestoreIcon from 'assets/icons/file-cabinet-trash/restore.svg';
import { styles } from './styles';

interface IDeletedActionsPopper {
  onDeleteFile: () => void;
  onRestoreFile: () => void;
}

export const DeletedActionsPopper = ({ onDeleteFile, onRestoreFile }: IDeletedActionsPopper) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleOpen = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setAnchorEl(e.currentTarget);
  };

  const handleClose = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const list = [
    {
      id: 1,
      label: 'restore',
      icon: <RestoreIcon />,
      disabled: false,
      handleClick: onRestoreFile,
    },
    {
      id: 2,
      label: 'Delete permanently',
      icon: <DeleteIcon />,
      disabled: false,
      handleClick: onDeleteFile,
    },
  ];

  return (
    <>
      <IconButton sx={styles.iconBtn} onClick={handleOpen} disableRipple>
        <VerticalDotsIcon />
      </IconButton>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        sx={styles.popover}
      >
        {list.map((item) => (
          <Button
            key={item.id}
            sx={styles.actionBtn}
            startIcon={item.icon}
            disabled={item?.disabled}
            onClick={(e) => {
              handleClose(e);
              item.handleClick();
            }}
          >
            {item.label}
          </Button>
        ))}
      </Popover>
    </>
  );
};
